import {Stack, styled} from '@mui/material'

export const BottomButtonsWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
}))

export const pdfViewStyle = {border: 'none'}
